/** Locale for marketing-page embeds — reads host page, not the widget build. */
export type WebInputLocale = 'cs' | 'en';

export function getWebInputLocale(): WebInputLocale {
  if (typeof document === 'undefined') return 'cs';

  const fromSlot = document
    .getElementById('app')
    ?.getAttribute('data-locale')
    ?.toLowerCase();
  if (fromSlot?.startsWith('en')) return 'en';
  if (fromSlot?.startsWith('cs')) return 'cs';

  const lang = document.documentElement.lang?.toLowerCase() ?? '';
  if (lang.startsWith('en')) return 'en';

  return 'cs';
}

const messages = {
  cs: {
    idleHint:
      'Načtu informace z vašich veřejných stránek a vytvořím podle nich AI asistenta.',
    learningDuration: 'Proces učení zabere 1-3 minuty',
  },
  en: {
    idleHint: 'I’ll read your public pages to set up your AI assistant.',
    learningDuration: 'The learning process takes 1-3 minutes',
  },
} as const;

export function tWebInput(key: keyof (typeof messages)['cs']): string {
  return messages[getWebInputLocale()][key];
}
